import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";

const ChiTietLog = (props) => {
    const { chitietlog, showModalChiTietLog, data } = props;
    const { showModalLog } = chitietlog;
    const { CreatedByUser, CreatedTime,Note } = data;

    // Close the modal when Escape key is pressed
    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            showModalChiTietLog();
        }
    };

    useEffect(() => {
        // Add keydown event listener when modal is open
        if (showModalLog) {
            document.addEventListener("keydown", handleKeyDown);
        }
        // Cleanup event listener on unmount or when modal is closed
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [showModalLog]); // Effect runs when showModalLog changes

    return (
        <Modal
            show={showModalLog}
            size="modal-dialog modal-lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold" id="myModalLabel16">
                    <span className="btn-icon-right">
                        <img src="/app-assets/images/icon-chi-tiet-lich-su.png" />
                    </span>
                    Chi tiết log
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={showModalChiTietLog}
                >
                    <img src="/app-assets/images/icon-dong-popup-v2.png" />
                </button>
            </Modal.Header>
            <Modal.Body className="">
                <div className="form form-horizontal">
                    <div className="form-body">
                        <div className="form-body">
                            <div className="form-group row ">
                                <label className="col-md-3 label-control"><span class="font-nguoi-nhan">Người thực hiện :</span></label>
                                <div className="col-md-8 font-nguoi-nhan" style={{ textAlign: "left" }}>{CreatedByUser}</div>
                                <label className="col-md-3 label-control"><span class="font-nguoi-nhan">Thời gian thực hiện :</span></label>
                                <div className="col-md-8 font-nguoi-nhan" style={{ textAlign: "left" }}>{CreatedTime}</div>
                                <label className="col-md-3 label-control"><span class="font-nguoi-nhan">Nội dung :</span></label>
                                <div className="col-md-8 font-nguoi-nhan" style={{ textAlign: "left" }}>{Note}</div>                                
                            </div>                            
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={showModalChiTietLog}
                >
                    <span>
                        <i className="mdi mdi-close"></i>
                    </span>
                    &nbsp;  Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};
export default ChiTietLog;
